<span *ngIf="status" class="status-container seat-status-text" fxLayoutAlign="start">
  <span fxLayoutAlign="end center">
    <svg width="15" height="10">
      <circle [class]="getSeatStatusColor()" class="status-dot" cx="5" cy="5" r="4" stroke-width="0" />
    </svg>
  </span>

  <span
    fxLayoutAlign="start center"
    [matMenuTriggerFor]="statusOverride"
    id="person-status"
    data-testid="card-person-status"
    [ngClass]="{ 'menu-button': true, 'disable-menu': !canEditPersonOnTeam() }"
    >{{ getSeatStatusText()
    }}<mat-icon id="status-override-action" *ngIf="canEditPersonOnTeam()">arrow_drop_down</mat-icon></span
  >
  <mat-menu #statusOverride="matMenu">
    <span class="seat-status">Override the status:</span>
    <button class="status-override" [disabled]="isPicked()" (click)="overridePicked()" id="person-picked" mat-menu-item>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="menu-item-text">
          <svg width="15" height="10">
            <circle class="getSeatStatusText()" class="status-dot Picked" cx="5" cy="5" r="4" stroke-width="0" />
          </svg>
          <span>Picked</span>
        </div>
        <mat-icon *ngIf="isPicked()">check</mat-icon>
      </div>
    </button>
    <button
      class="status-override"
      [disabled]="isInvited()"
      (click)="overrideInvited()"
      id="person-invited"
      mat-menu-item
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="menu-item-text">
          <svg width="15" height="10">
            <circle class="getSeatStatusText()" class="status-dot Invited" cx="5" cy="5" r="4" stroke-width="0" />
          </svg>
          <span>Invited</span>
        </div>
        <mat-icon *ngIf="isInvited()">check</mat-icon>
      </div>
    </button>
    <button
      class="status-override"
      [disabled]="isNoResponse()"
      (click)="overrideNoResponse()"
      id="person-noresponse"
      mat-menu-item
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="menu-item-text">
          <svg width="15" height="10">
            <circle class="getSeatStatusText()" class="status-dot NoResponse" cx="5" cy="5" r="4" stroke-width="0" />
          </svg>
          <span>No Response</span>
        </div>
        <mat-icon *ngIf="isNoResponse()">check</mat-icon>
      </div>
    </button>
    <button
      class="status-override"
      [disabled]="isAccepted()"
      (click)="overrideAccepted()"
      id="person-accepted"
      mat-menu-item
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="menu-item-text">
          <svg width="15" height="10">
            <circle class="getSeatStatusText()" class="status-dot Accepted" cx="5" cy="5" r="4" stroke-width="0" />
          </svg>
          <span>Accepted</span>
        </div>
        <mat-icon *ngIf="isAccepted()">check</mat-icon>
      </div>
    </button>
    <button
      class="status-override"
      [disabled]="isDeclined()"
      (click)="overrideDeclined()"
      id="person-declined"
      mat-menu-item
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="menu-item-text">
          <svg width="15" height="10">
            <circle class="getSeatStatusText()" class="status-dot Declined" cx="5" cy="5" r="4" stroke-width="0" />
          </svg>
          <span>Declined</span>
        </div>
        <mat-icon *ngIf="isDeclined()">check</mat-icon>
      </div>
    </button>
    <button class="status-override" [disabled]="isNoShow()" (click)="overrideNoShow()" id="person-noshow" mat-menu-item>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="menu-item-text">
          <svg width="15" height="10">
            <circle class="getSeatStatusText()" class="status-dot NoShow" cx="5" cy="5" r="4" stroke-width="0" />
          </svg>
          <span>No Show</span>
        </div>
        <mat-icon *ngIf="isNoShow()">check</mat-icon>
      </div>
    </button>
  </mat-menu>
</span>
